import React from "react";
import Radio from "@material-ui/core/Radio";
import RadioGroup from "@material-ui/core/RadioGroup";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import FormControl from "@material-ui/core/FormControl";
import Typography from "@material-ui/core/Typography";
import { ThemeProvider } from "@material-ui/styles";
import { createMuiTheme } from "@material-ui/core";

export default function EligibilityStaticDateFilter(props) {
    const { handleFilterChange, value, disabled, theme } = props;

    const materialTheme = createMuiTheme({
        palette: {
            primary: {
                main: theme.primaryColor
            },
            secondary: {
                main: theme.primaryColor
            },
        },
        overrides: {
            MuiTypography: {
                body1: {
                    fontFamily: "Avenir",
                    fontSize: 16,
                },
                h5: {
                    fontFamily: "Avenir",
                    fontSize: "16px",
                    fontWeight: "lighter",
                },
            },
            MuiFormControlLabel: {
                label: {
                    color: theme.textColorPrimary
                }
            }
        },
    });

    return (
        <ThemeProvider theme={materialTheme}>
            <Typography variant="h5" tabIndex="0">Filter appointments by start time:</Typography>
            <FormControl component="fieldset">
                <RadioGroup
                    row
                    value={value || "all"}
                    name="timePeriod"
                    aria-label="timePeriod"
                    onChange={(event) => handleFilterChange(event.target.value)}
                >
                    <FormControlLabel
                        value="all"
                        control={<Radio />}
                        label="Anytime"
                        disabled={disabled}
                    />
                    <FormControlLabel
                        value="am"
                        control={<Radio />}
                        label="Morning"
                        disabled={disabled}
                    />
                    <FormControlLabel
                        value="pm"
                        control={<Radio />}
                        label="Afternoon"
                        disabled={disabled}
                    />
                </RadioGroup>
            </FormControl>
        </ThemeProvider>
    );
}
